module.exports = __webpack_public_path__ + "static/bigcommerce_3-c21e4ecb9ea47ad7372ba670e6523fca.png";